// extracted by mini-css-extract-plugin
module.exports = {"icon":"_93444fe79c--icon--2f8xK"};